import _extends from "@babel/runtime-corejs3/helpers/extends";

var _ADJUSTMENT_MAP, _POINTER_ROTATION;

import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import { positions } from "../../../enums"; // Model that describes the calculation of the next position of the tooltip

var ADJUSTMENT_MAP = (_ADJUSTMENT_MAP = {}, _ADJUSTMENT_MAP[positions.TOP] = {
  x: positions.TOP_LEFT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.TOP_LEFT] = {
  x: positions.TOP_RIGHT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.TOP_RIGHT] = {
  x: positions.RIGHT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.RIGHT] = {
  x: positions.TOP,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.BOTTOM] = {
  x: positions.BOTTOM_LEFT,
  y: positions.TOP
}, _ADJUSTMENT_MAP[positions.BOTTOM_LEFT] = {
  x: positions.BOTTOM_RIGHT,
  y: positions.TOP
}, _ADJUSTMENT_MAP[positions.BOTTOM_RIGHT] = {
  x: positions.LEFT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP[positions.LEFT] = {
  x: positions.RIGHT,
  y: positions.BOTTOM
}, _ADJUSTMENT_MAP); // Model that describes the calculation of pointer rotation

export var POINTER_ROTATION = (_POINTER_ROTATION = {}, _POINTER_ROTATION[positions.TOP] = 0, _POINTER_ROTATION[positions.TOP_LEFT] = 0, _POINTER_ROTATION[positions.TOP_RIGHT] = 0, _POINTER_ROTATION[positions.RIGHT] = 90, _POINTER_ROTATION[positions.BOTTOM] = 180, _POINTER_ROTATION[positions.BOTTOM_LEFT] = 180, _POINTER_ROTATION[positions.BOTTOM_RIGHT] = 180, _POINTER_ROTATION[positions.LEFT] = 270, _POINTER_ROTATION); //we need to slightly adjust the pixel position of the pointer based on the pointer square box with and height so that we can pixel-perfect position it or use the size of in the calculation in _tooltipAndPointerByCoordinates

var POINTER_INDENT = 6;
/**
 * Looks at the tooltip placement on the current DOM. If the tooltip is within screen bounds for the X and Y axis (which means the tooltip should be FULLY visible on the screen for the user) then it will return an enum string position from which we later build coordinates, OR it returns NULL when no adjustments are needed for the current position
 * @param {number} width - tooltip width
 * @param {number} height - tooltip height
 * @param {number} indentTop - top indent
 * @param {number} indentLeft - left indent
 * @param {string} position - an enum string value of a direction that the tooltip should be positioned at; used to calculate the X-Y coordinates
 * @returns {string}  - returns new position string enum position or null for when the tooltip is correctly visible on the screen
 */

var _getAdjustedTooltipPosition = function _getAdjustedTooltipPosition(_ref) {
  var width = _ref.width,
      height = _ref.height,
      indentTop = _ref.indentTop,
      indentLeft = _ref.indentLeft,
      position = _ref.position;
  // visible page width
  var screenWidth = window.innerWidth; // visible page height

  var screenHeight = window.innerHeight;
  var tooltipX = indentLeft + width;
  var tooltipY = indentTop + height; //if the vertical alignment(Y-axis) of the tooltip is outside the visible screen then try to adjust the Y coordinate for the tooltip

  if (indentTop < 0 || tooltipY > screenHeight) {
    return ADJUSTMENT_MAP[position].y;
  } //if the horizontal alignment(X-axis) of the tooltip is outside the visible screen then try to adjust the X coordinate for the tooltip


  if (indentLeft < 0 || tooltipX > screenWidth) {
    return ADJUSTMENT_MAP[position].x;
  } //else we do not need to adjust the position and we can simply return the original position letting the app know we have reached success


  return position;
};
/**
 * Returns a complex object of coordinates based on the [position] value set by the user, relative to the child component that the tooltip wraps around.That value is represented by  the top and left css values for positioning the tooltip box and the top and left css values for the tooltips arrow pointer.
 * @param {string} position - an enum string value of a direction that the tooltip should be positioned at; used to calculate the X-Y coordinates
 * @param {childLeft} childrenBounding - DOMRect from children element
 * @param {childBottom} childrenBounding - DOMRect from children element
 * @param {childWidth} childrenBounding - DOMRect from children element
 * @returns {object} - {
  tooltipX: number, - the left css property value for the tooltip
  tooltipY: number, - the top css property value for the tooltip
  pointerX: number, - the left css property value for the pointer of the tooltip
  pointerY: number, - the top css property value for the pointer of the tooltip
}
 */


var _tooltipAndPointerByCoordinates = function _tooltipAndPointerByCoordinates(_ref2) {
  var position = _ref2.position,
      childLeft = _ref2.childLeft,
      childBottom = _ref2.childBottom,
      childWidth = _ref2.childWidth,
      childTop = _ref2.childTop,
      childHeight = _ref2.childHeight,
      tooltipWidth = _ref2.tooltipWidth,
      tooltipHeight = _ref2.tooltipHeight;

  switch (position) {
    case positions.BOTTOM:
      return {
        tooltipX: childLeft + childWidth / 2 - tooltipWidth / 2,
        tooltipY: childBottom + POINTER_INDENT,
        pointerX: tooltipWidth / 2 - POINTER_INDENT,
        pointerY: -POINTER_INDENT
      };

    case positions.BOTTOM_RIGHT:
      return {
        tooltipX: childLeft,
        tooltipY: childBottom + POINTER_INDENT,
        pointerX: POINTER_INDENT,
        pointerY: -POINTER_INDENT
      };

    case positions.BOTTOM_LEFT:
      return {
        tooltipX: childLeft + childWidth - tooltipWidth,
        tooltipY: childBottom + POINTER_INDENT,
        pointerX: tooltipWidth - POINTER_INDENT * 3,
        pointerY: -POINTER_INDENT
      };

    case positions.TOP:
      return {
        tooltipX: childLeft + childWidth / 2 - tooltipWidth / 2,
        tooltipY: childTop - tooltipHeight - POINTER_INDENT,
        pointerX: tooltipWidth / 2 - POINTER_INDENT,
        pointerY: tooltipHeight
      };

    case positions.TOP_RIGHT:
      return {
        tooltipX: childLeft,
        tooltipY: childTop - tooltipHeight - POINTER_INDENT,
        pointerX: POINTER_INDENT,
        pointerY: tooltipHeight
      };

    case positions.TOP_LEFT:
      return {
        tooltipX: childLeft + childWidth - tooltipWidth,
        tooltipY: childTop - tooltipHeight - POINTER_INDENT,
        pointerX: tooltipWidth - POINTER_INDENT * 3,
        pointerY: tooltipHeight
      };

    case positions.LEFT:
      return {
        tooltipX: childLeft - tooltipWidth - POINTER_INDENT,
        tooltipY: childTop + childHeight / 2 - tooltipHeight / 2,
        pointerX: tooltipWidth - POINTER_INDENT / 2,
        pointerY: tooltipHeight / 2 - POINTER_INDENT / 2
      };

    case positions.RIGHT:
      return {
        tooltipX: childLeft + childWidth + POINTER_INDENT,
        tooltipY: childTop + childHeight / 2 - tooltipHeight / 2,
        pointerX: -(POINTER_INDENT + POINTER_INDENT / 2),
        pointerY: tooltipHeight / 2 - POINTER_INDENT / 2
      };
  }
};
/**
 * Calculate tooltip coordinates in window
 * @param {string} position - current position
 * @param {object} childrenBounding - DOMRect from children element
 * @param {object} tooltipBounding - DOMRect from tooltip
 * @param {number} correctionIteration - function iteration
 * @returns {object} - returns object { x: number, y: number, pointerX: number, pointerY: number, position: string }
 */


export var getTooltipCoordinates = function getTooltipCoordinates(position, childrenBounding, tooltipBounding) {
  var tooltipWidth = tooltipBounding.width,
      tooltipHeight = tooltipBounding.height;
  var childWidth = childrenBounding.width,
      childHeight = childrenBounding.height,
      childLeft = childrenBounding.left,
      childTop = childrenBounding.top,
      childBottom = childrenBounding.bottom; //We now try to do a cycle of attempts where we adjust the tooltip on the screen until it ends up visible. We can end up with one or more attempts until we hit a success.

  var adjustedPosition = position;
  var coordinates;
  var positionAttempts = []; //we need to store the position we attempt to render the tooltip as we loop through all possible positions; this is to break through an infinite loop potential if there are no possible positions to place it in

  do {
    positionAttempts.push(adjustedPosition); //grab the coordinates needed for the tooltip and its pointer

    coordinates = _tooltipAndPointerByCoordinates({
      position: adjustedPosition,
      childLeft: childLeft,
      childBottom: childBottom,
      childWidth: childWidth,
      childTop: childTop,
      childHeight: childHeight,
      tooltipWidth: tooltipWidth,
      tooltipHeight: tooltipHeight
    });
    /*
    Once we have the coordinates we then try to see if we require an adjustment of the position of the tooltip.
     On the first iteration this is generally required as the position is not properly set.
     On consecutive adjustments we use ADJUSTMENT_MAP to bounce around the element until we find a proper position where we can place the tooltip. This position can be different than the one the user has specify, if the original position cannot visibly display the tooltip.
    */

    var newPosition = _getAdjustedTooltipPosition({
      width: tooltipWidth,
      height: tooltipHeight,
      indentTop: coordinates.tooltipY,
      indentLeft: coordinates.tooltipX,
      position: adjustedPosition
    }); //we need to prevent setting up a new position if it has been an attempt in the past for it


    if (_indexOfInstanceProperty(positionAttempts).call(positionAttempts, newPosition) === -1) adjustedPosition = newPosition; //keep looping as long as we continue to adjust the position
  } while (_indexOfInstanceProperty(positionAttempts).call(positionAttempts, adjustedPosition) === -1 //break loop if we are attempting to use the same position again, this means we did not have to adjust the original position or we simply failed to find a suitable position to render it at
  );

  return _extends({}, coordinates, {
    position: adjustedPosition
  });
};
//# sourceMappingURL=utils.js.map